import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as c } from "react";
import { m as d } from "./tss-DN0acMKN.mjs";
import { A as f } from "./adorned-text-ngaJgM_T.mjs";
const x = d()(({ palette: i, typography: e }, { hasMargin: t }) => ({
  root: {
    color: i.gray[1e3],
    lineHeight: e.medium.lineHeight,
    marginBottom: t ? 0 : void 0
  },
  icon: {
    display: "inline-flex",
    fill: i.primary.main,
    flexDirection: "column",
    justifyContent: "center",
    marginRight: "8px",
    minHeight: "22px"
  },
  label: {
    alignItems: "center",
    display: "flex",
    fontSize: e.large.fontSize,
    fontWeight: e.fontWeightSemibold
  },
  subtitle: {
    color: i.gray[800],
    fontSize: e.small.fontSize,
    fontWeight: e.fontWeightRegular
  }
})), b = c(
  ({ biId: i, classes: e = {}, hasMargin: t = !0, icon: l, label: r, size: g = "medium", subtitle: s, ...m }, a) => {
    const { classes: o } = x({ hasMargin: t }, { props: { classes: e } });
    return /* @__PURE__ */ n.jsx(
      f,
      {
        adornment: l,
        alignItems: "center",
        biId: i,
        classes: o.root,
        component: "div",
        ref: a,
        ...m,
        "data-fabric-component": "SectionHeader",
        children: /* @__PURE__ */ n.jsxs("div", { children: [
          /* @__PURE__ */ n.jsx("div", { className: o.label, children: r }),
          s ? /* @__PURE__ */ n.jsx("div", { className: o.subtitle, children: s }) : null
        ] })
      }
    );
  }
);
export {
  b as S
};
//# sourceMappingURL=section-header-Bma-sii2.mjs.map
